import PageMeta from "../../components/common/PageMeta";
import MessageHistory from "../../components/hotel/MessageHistory";

export default function MessageHistoryPage() {
  return (
    <>
      <PageMeta
        title="Message History - SelfServe"
        description="SelfServe Message History Dashboard"
      />
      <div className="col-span-12">
        <MessageHistory />
      </div>
    </>
  );
}
